import React from "react";
import { Link } from "react-router-dom";

const renderContent = () => {
  return (
    <div>
      <div className="register-steps-container">
        <div className="logo-container">
          <Link to="/">
            <img src="/images/osh_logo.png" alt="Company Logo" width="350" />
          </Link>
        </div>
        <div className="separator"></div>
        <div className="intro-text">
          <h1>What brings you to One support hub?</h1>
          {/* <h2>What brings you to WillCare?</h2> */}
        </div>
        <div>
          <ul>
            <li>
              <Link to="/register/client/who">
                <button className="support-button">Find Support</button>
              </Link>
              <span className="arrow">{">"}</span>
            </li>
            <li>
              <Link to="/register/worker/who">
                <button className="support-button">Give Support</button>
              </Link>
              <span className="arrow">{">"}</span>
            </li>
          </ul>
        </div>
        <div className="signin-container">
          <span>Already have an account?</span>
          <Link className="what-brings-link" to="/login">
            Log In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default renderContent;
